<template>
    <div class="d-flex align-items-center justify-content-end" style="height: 3em;">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'Actions',
}
</script>
